var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle32CSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 37 49",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  fillRule: "evenodd",
  d: "M19 47.999H5l-.725-7.251a2.5 2.5 0 0 1 2.487-2.749H19v10Zm0 0h14l.725-7.251a2.5 2.5 0 0 0-2.487-2.749H19v10Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M3 47.999a1 1 0 0 1 1-1h30a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M13.793 3.274A2.5 2.5 0 0 1 16.283 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6A2.5 2.5 0 0 1 22.262 12h-6.524a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M15.738 2c-.686 0-1.314.388-1.62 1.002l-.223.445a1 1 0 1 1-1.79-.894l.223-.446A3.813 3.813 0 0 1 15.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445A1.812 1.812 0 0 0 22.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M36.998 32.5a2.5 2.5 0 0 1-2.5 2.5h-31a2.5 2.5 0 0 1-2.5-2.5v-15a2.5 2.5 0 0 1 2.5-2.5h31a2.5 2.5 0 0 1 2.5 2.5v15Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M3.498 33h31a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5h-31a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5Zm31 2a2.5 2.5 0 0 0 2.5-2.5v-15a2.5 2.5 0 0 0-2.5-2.5h-31a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h31Z",
  clipRule: "evenodd"
})));
SvgRectangle32CSelected.viewBox = '0 0 37 49';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle32CSelected);
export default ForwardRef;